import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import DatePickerInput from "../../../share/input/DatePicker";
import { ReactComponent as Cancel } from "../../../../Assets/Image/svg/cancel.svg";
import { BtnPrimary } from "../../../share/buttons/Btn";
import Inputs from "../../../share/input/Inputs";
import SupportTicketQuill from "../../SupportTicket/SupportTicketQuill";
import { ReactComponent as Upload } from "../../../../Assets/Image/svg/Upload.svg";
import { Modal } from "../../../share/modal/Modal";
import DragAndDrop from "../../../share/dragAndDropFile/DragAndDrop";
import useFetch from "../../../../Hooks/useFetch";
import MessageQuill from "../../Message/MessageQuill";
import { useCreate } from "../../../../Context/CreateContext";

const SupportersInfo = ({ close, status, edit, setEdit, getSupporter }) => {
    const { phaseStatus, setPhaseStatus, bootCamp } = useCreate();

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();
    const onSubmit = (data) => console.log("data", data);
    const [upload1, setUpload1] = useState(false);
    const [file, setFile] = useState();
    const [description, setDescription] = useState();
    const [support, setSupport] = useState({
        id: "",
        supporter_name: "",
        supporter_website: "",
        supporter_description: "",
    });
    const [call, setCall] = useState("");

    const handleModal = () => {
        setUpload1((perv) => !perv);
    };
    console.log("upload1", upload1);

    const closeModal = (e) => {
        e.stopPropagation();
        close();
        setSupport({
            id: "",
            supporter_name: "",
            supporter_website: "",
            supporter_description: "",
            ticket_end_time: "",
        });

        setEdit("");
    };

    useEffect(() => {
        if (edit) {
            getSupportId.reFetch();
        }
    }, [edit]);

    useEffect(() => {
        setSupport({ ...support, supporter_description: description });
    }, [description]);

    const newSupport = useFetch({
        method: "POST",
        url: `BootCampSupporterService`,
        noHeader: false,
        trigger: false,
        data: call,
        caller: getSupporter,
    });

    const getSupportId = useFetch({
        method: "GET",
        url: `BootCampSupporterService/${edit}`,
        noHeader: false,
        setter: setSupport,
    });

    const editSupport = useFetch({
        method: "PATCH",
        url: `BootCampSupporterService/${edit}`,
        noHeader: false,
        caller: getSupporter,
        data: support,
    });

    const submitForm = () => {
        if (edit) {
            console.log("edit submit");
            editSupport.reFetch();
            close();
        } else {
            const formData = new FormData();

            formData.append("bootcamp", bootCamp?.id);
            formData.append("supporter_name", support.supporter_name);
            formData.append("supporter_website", support.supporter_website);
            formData.append(
                "supporter_description",
                support.supporter_description
            );

            setCall(formData);
            newSupport.reFetch();

            close();

            setSupport({
                id: "",
                supporter_name: "",
                supporter_website: "",
                supporter_description: "",
            });
        }
    };

    return (
        <div className="AddnewsupportTicket relative">
            <button
                onClick={closeModal}
                className="AddnewsupportTicket-cancel absolute  "
            >
                <div>
                    <Cancel />
                </div>
            </button>
            <h3 className=" text-center text-[#77498F] text-[20px] font-bold mb-20">
                {status ? "اطلاعات تکلیف" : "برگزارکنندگان و حامیان"}
            </h3>
            <form onSubmit={handleSubmit(submitForm)}>
                <input
                    register={{
                        required: {
                            value: true,
                            message: "Enter Name",
                        },
                    }}
                    type="text"
                    name="name"
                    control={control}
                    placeholder="نام حامی*"
                    className="input border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem]"
                    value={support.supporter_name}
                    onChange={(e) =>
                        setSupport({
                            ...support,
                            supporter_name: e.target.value,
                        })
                    }
                />
                <input
                    register={{
                        required: {
                            value: true,
                            message: "Enter Name",
                        },
                    }}
                    type="text"
                    name="name"
                    control={control}
                    placeholder="وب‌سایت"
                    className="input border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem]"
                    value={support.supporter_website}
                    onChange={(e) =>
                        setSupport({
                            ...support,
                            supporter_website: e.target.value,
                        })
                    }
                />
                <MessageQuill
                    placeholder="توضیحات *"
                    value={support.supporter_description}
                    setValue={setDescription}
                />

                <div
                    className="w-3/5 py-[20px] px-[25px] flex border-gray border-[1px] text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] justify-between cursor-pointer"
                    onClick={() => handleModal()}
                >
                    <span>بارگزاری لوگو حامی</span>
                    <Upload />
                </div>
                <div className="flex gap-48 self-end">
                    <BtnPrimary
                        className=" py-[20px] px-[81px] mr-auto"
                        text="ثبت"
                    />
                </div>
            </form>
            <Modal show={upload1} closeModal={handleModal}>
                <DragAndDrop
                    setFile={setFile}
                    close={handleModal}
                    label=""
                    {...register("photo", { required: false })}
                    error={errors["photo"]}
                    accept=".png , .jpg"
                    type="image"
                />
            </Modal>
        </div>
    );
};

export default SupportersInfo;
